import { render, staticRenderFns } from "./info-card.vue?vue&type=template&id=3d4cafd8&scoped=true&"
import script from "./info-card.vue?vue&type=script&lang=ts&"
export * from "./info-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4cafd8",
  null
  
)

export default component.exports